module.exports = __webpack_public_path__ + "img/dicora.1830d239.png";